import * as React from 'react';
import { Nav, NavDropdown, NavItem as BsNavItem } from 'react-bootstrap';
import LinkContainer from 'react-router-bootstrap/lib/LinkContainer';

import { NavItem } from '../../../common/models';

interface HeaderNavBarProps { links: NavItem[]; }

export const HeaderNavBar = (props: HeaderNavBarProps) => (
    <Nav>
      {props.links.map(link => link.children && link.children.length > 0 ?
        (
          <NavDropdown
            key={link.route}
            title={link.text}
            id={cleanId(link.route)}
            className={link.active ? 'active' : ''}
          >
            {link.children.map(childLink => (
              <LinkContainer to={childLink.route} key={childLink.route}>
                <BsNavItem href={childLink.route}>{childLink.text}</BsNavItem>
              </LinkContainer>
            ))}
          </NavDropdown>
        ) :
        (
          link.route.startsWith('http') ?
            <BsNavItem
              key={link.route}
              href={link.route}
              className={link.active ? 'active' : ''}
            >
              {link.text}
            </BsNavItem>
            : ( <LinkContainer to={link.route} key={link.route}>
              <BsNavItem href={link.route} className={link.active ? 'active' : ''}>{link.text}</BsNavItem>
            </LinkContainer> )
        )
      )}
    </Nav>
  );

function cleanId(route: string): string {
  return route.replace(/https?:\/\//, '').replace('/', '-');
}



// WEBPACK FOOTER //
// ./src/gs-core/client/react/layout/HeaderNavBar.tsx